import CertificateItemTableModal from './CertificateItemTableModal';

export default CertificateItemTableModal;
